export default {
    themeChosen(themeTitle) {
        this.event('custom_theme_chosen', {
            'event_category': 'Theme Chosen',
            'event_label': themeTitle,
            'theme_title': themeTitle,
        });
    },

    caseChosen(caseTitle) {
        this.event('custom_case_chosen', {
            'event_category': 'Case Chosen',
            'event_label': caseTitle,
            'case_title': caseTitle,
        });
    },

    caseStarted(caseTitle) {
        this.event('custom_case_started', {
            'event_category': 'Case Started',
            'event_label': caseTitle,
            'case_title': caseTitle,
        });
    },

    caseEnded(caseTitle, secondsTaken) {
        this.event('custom_case_ended', {
            'event_category': 'Case Ended',
            'event_label': caseTitle,
            'case_title': caseTitle,
            'seconds_taken': secondsTaken,
        });
    },
};
